// /src/components/donate/supportChoice/supportChoiceEvents.js

export const SUPPORT_CHOICE_OPEN_CHANGE = 'support-choice:open-change';
export const SUPPORT_CHOICE_STATUS_CHANGED = 'support-choice:status-changed';

export function openSupportChoiceChange() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(SUPPORT_CHOICE_OPEN_CHANGE));
}

export function emitSupportChoiceStatusChanged(detail = null) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(SUPPORT_CHOICE_STATUS_CHANGED, { detail }));
}
